// @owners { team: patients }
import { ShipmentFeeTypeMap } from '@alto/scriptdash/alto/orders/types/v1/shipment_fee_type';
import { type MinimalShipmentFee } from '@alto/scriptdash/alto/scheduling/types/v1/minimal_shipment_fee';
import { type ShipmentFee } from '~shared/types/shipments';

export const includesAsapDeliveryFee = (shipment_fees: MinimalShipmentFee[] | ShipmentFee[] | null | undefined) => {
  return shipment_fees?.some((fee) => fee.fee_type === ShipmentFeeTypeMap.ASAP_DELIVERY) ?? false;
};
